import { isBefore, isSameDay, addDays, isPast, isToday } from "date-fns";

import { getSystemLocale } from "../../../lib/locale/locale";

export function hasUnavailbleDayInBetween(
  firstDay: Date,
  secondDay: Date,
  availableDates?: Date[]
) {
  for (let i = 1; isBefore(addDays(firstDay, i), secondDay); i++) {
    if (!availableDates?.some((d) => isSameDay(d, addDays(firstDay, i)))) {
      return true;
    }
  }
  return false;
}

export function isTodayOrPast(date: Date) {
  return isPast(date) && !isToday(date);
}

export function range(number: number) {
  const range: number[] = [];
  for (let i = 0; i < number; i++) {
    range.push(i);
  }
  return range;
}

// 0 as Sunday
type WeekDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export function startOfWeek(): WeekDay {
  const locale = new (Intl as any).Locale(getSystemLocale());
  // 7 as Sunday by Intl.Locale.prototype.getWeekInfo().firstDay https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo
  let firstDay = 7;

  // @ts-ignore
  if (locale.getWeekInfo && locale.getWeekInfo()) {
    // @ts-ignore
    firstDay = locale.getWeekInfo().firstDay;
    // @ts-ignore
  } else if (locale.weekInfo) {
    // @ts-ignore
    firstDay = locale.weekInfo.firstDay;
  }

  if (firstDay === 7) {
    return 0;
  }
  return firstDay as WeekDay;
}

const sundayWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function getWeekDaysByLocale(firstDayOfWeek: WeekDay = startOfWeek()) {
  const slice1 = sundayWeek.slice(0, firstDayOfWeek);
  const slice2 = sundayWeek.slice(firstDayOfWeek);
  return slice2.concat(slice1);
}
/**
 * Default index parameter is 0 as Sunday. `firstDayOfWeek` defaults to the
 * browser-locale week start; callers pass an explicit value to override it.
 */
export function convertWeekIndexByLocale(
  index: WeekDay,
  firstDayOfWeek: WeekDay = startOfWeek()
) {
  const weekDay = sundayWeek[index];
  const localeWeekDays = getWeekDaysByLocale(firstDayOfWeek);
  return localeWeekDays.findIndex((d) => d === weekDay);
}
